<template>
  <el-card v-loading="loading" class="pro-detail">
    <!-- 基本信息 -->
    <el-alert
      class="info-title"
      title="账册库存导入"
      type="info"
      :closable="false"
    >
    </el-alert>
    <el-row class="info">
      <el-row>
        <el-col class="title" :span="24">
          <h2>导入账册库存文件须知</h2>
          <el-tag type="info" effect="dark"> 注意 </el-tag>
        </el-col>
        <el-col :span="24">
          <ul class="oms-list">
            <li>
              1.请选择要导入的Excel文件,文件格式为.xls
              <el-link @click="downloadTemplate">【模板下载】 </el-link>
            </li>
            <li>2.导入条目数限制为每次200条,请注意导入的数据数量</li>
            <li>3.请不要调换Excel的列顺序</li>
            <li>
              4.导入如果提示行校验不通过，请检查对应行：必填字段是否都填写
            </li>
          </ul>
        </el-col>
        <!-- <el-col :span="24">
                    <div class="pampas-import-statistics">
                        <div>导入统计:</div>
                        <el-badge :value="statisticObj.importTotal" class="item">
                            需要导出数量
                        </el-badge>
                        <el-badge :value="statisticObj.invalidRowNum" class="item">
                            校验不通过数量
                        </el-badge>
                    </div>
                </el-col> -->
        <el-col :span="24">
          <div class="pampas-import-file-container">
            <label>选择要导入文件:</label>
            <div class="pampas-file-upload">
              <input
                :title="localFilePath"
                readonly
                type="text"
                :value="localFilePath"
              />

              <el-upload
                class="avatar-uploader"
                action="/file.api"
                accept=".xls, .xlsx"
                :show-file-list="false"
                :data="uploadData"
                :name="uploadName"
                :on-success="handleAvatarSuccess"
              >
                <el-button size="mini" type="primary">上传</el-button>
              </el-upload>
              <el-button
                v-on:click="importOrderData"
                v-show="showImportBtn"
                size="mini"
                type="primary"
              >
                确定导入
              </el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="pampas-import-preview">
            <label>导入结果信息：</label>
            <div>
              <p>导入预览：</p>
            </div>
          </div>
          <div>
            <element-table
              :rowClassName="rowClassName"
              headerClassName="stock-table"
              :data="excelRows"
              :columns="excelColumns"
              :loading="loading"
              border
            ></element-table>
          </div>
        </el-col>
      </el-row>
    </el-row>
  </el-card>
</template>

<script>
import ElementTable from "@/components/ElementTable";
import { formatDate } from "@/utils/common";
import { CONST_VD_IMGPREFIX } from "@/config/constant";
import Page from "@/mixin/Page";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      showImportBtn: false,
      localFilePath: "Choose File",
      uploadData: {
        _aid: 401,
      },
      uploadName: "CPRODUCT_IMG.xlsx",
      loading: false,
      excelRows: [],
      statisticObj: {
        importTotal: 0,
        invalidRowNum: 0,
        importSuccess: 0,
        importFail: 0,
      },
      excelColumns: [
        {
          title: "货主id",
          width: 100,
          key: "customerId",
          align: "center",
        },
        {
          title: "账册编号",
          width: 250,
          key: "accountBookNo",
          align: "center",
        },
        {
          title: "商品条码",
          width: 250,
          key: "barcodes",
          align: "center",
        },
        {
          title: "料号",
          width: 200,
          key: "itemNo",
          align: "center",
        },
        {
          title: "金二序号",
          width: 200,
          key: "itemRecordNo",
          align: "center",
        },
        {
          title: "hs编码",
          width: 120,
          key: "hsCode",
          align: "center",
        },
        {
          title: "备案名称",
          width: 330,
          key: "declareName",
          align: "center",
        },
        {
          title: "原产国",
          width: 130,
          key: "origin",
          align: "center",
        },
        {
          title: "毛重(KG)",
          width: 130,
          key: "grossWeight",
          align: "center",
        },
        {
          title: "净重(KG)",
          width: 150,
          key: "netWeight",
          align: "center",
        },
        {
          title: "申报单位",
          width: 130,
          key: "measuringUnit",
          align: "center",
        },
        {
          title: "第一计量单位",
          width: 200,
          key: "firstMeasuringUnit",
          align: "center",
        },
        {
          title: "第一计量单位值",
          width: 180,
          key: "firstValue",
          align: "center",
        },
        {
          title: "第二计量单位",
          width: 200,
          key: "secondMeasuringUnit",
          align: "center",
        },
        {
          title: "第二计量单位值",
          width: 180,
          key: "secondValue",
          align: "center",
        },
        {
          title: "申报价格（CNY元）",
          width: 230,
          key: "price",
          align: "center",
        },
        {
          title: "海关账册规格型号",
          width: 150,
          key: "gmodel",
          align: "center",
        },
        {
          title: "长（CM）",
          width: 100,
          key: "length",
          align: "center",
        },
        {
          title: "宽（CM）",
          width: 100,
          key: "width",
          align: "center",
        },
        {
          title: "高（CM）",
          width: 100,
          key: "height",
          align: "center",
        },
        {
          title: "海关库存数量",
          width: 200,
          key: "stockCustomsNum",
          align: "center",
        },
        {
          title: "备注",
          width: 200,
          key: "remark",
          align: "center",
        },
        {
          title: "错误信息",
          key: "errorMsg",
          minWidth: 150,
          align: "center",
          render: (h, param) => {
            let msg = (param.row || {}).errorMsg;
            let prop = { disabled: msg == null };
            return (
              <div>
                <el-tooltip
                  {...prop}
                  className="item"
                  effect="light"
                  placement="top"
                >
                  <div slot="content">{msg}</div>
                  <el-button>查看错误</el-button>
                </el-tooltip>
              </div>
            );
          },
        },
      ],
    };
  },
  mixins: [Page],
  components: {
    ElementTable,
  },
  created() {
    //this.fetch();
  },
  mounted() {},
  methods: {
    ...mapActions("record", ["import", "preview", "export"]),
    downloadTemplate() {
      window.open(
        process.env.BASE_URL + "templates/账册库存信息新增导入.xlsx"
      );
    },
    // 获取入库单详情
    importOrderData() {
      this.loading = true;
      this.import({
        request: { importList: this.excelRows },
      })
        .then((res) => {
          this.loading = false;
          if (!res.value) {
            this.$message.warning("导入数据无效");
          } else {
            this.$message.success("导入成功");
          }
          this.showImportBtn = false;
          this.excelRows = [];
          this.localFilePath = "Choose File";
        })
        .catch((err) => {
          this.loading = false;
          this.$message.warning("导入数据无效");
          this.showImportBtn = false;
          this.excelRows = [];
          this.localFilePath = "Choose File";
        });
    },
    rowClassName(param) {
      let row = param.row;
      if (row.errorMsg != null && row.errorMsg.trim().length > 0) {
        return "table-row-danger";
      }
      return "";
    },
    handleAvatarSuccess(res, file) {
      this.localFilePath = file.name;
      let filUrl =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0][this.uploadName];
      this.loading = true;
      this.preview({
        fileUrl: filUrl,
      })
        .then((res) => {
          this.loading = false;
          this.excelRows = res.previewList;
          if (res.result) {
            this.showImportBtn = true;
          } else {
            this.$message.error(res.resultMsg);
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    formatDate,
  },
};
</script>

<style lang="scss">
.el-table .table-row-danger {
  background: #f56c6c;
}

.pampas-file-upload {
  button {
    margin-left: 5px;
  }
}

.avatar-uploader {
  display: inline-block;
}

.pro-detail {
  .info-title {
    height: 64px;
    background: #f5f5f5;
    color: #17181a;
    // font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .info {
    padding: 10px 20px 30px;

    .title {
      line-height: 100%;

      h2 {
        display: inline-block;
        vertical-align: middle;
      }

      span {
        vertical-align: middle;
        background: #777777;
        color: #f8f8f8;
      }
    }
  }

  .el-alert {
    margin-bottom: 10px;
  }

  .el-alert__title {
    font-size: 20px;
  }

  .el-alert__content {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .tip {
      color: #ff3333;
    }
  }
}

.oms-list {
  margin: 0;
  padding: 0;

  li {
    list-style: none;
    margin: 0;
    padding: 6px 0;
    color: black;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
  }
}

.pampas-import-statistics {
  border-top: 2px solid #bccde6;
  margin-top: 15px;
  padding: 12px 0;
  font-weight: 600;

  & > div {
    margin: 0 10px;
    padding: 3px 0;
    color: #5a9fd6;
    position: relative;
    vertical-align: middle;
    display: inline-block;

    & > sup {
      position: relative !important;
      right: 0 !important;
      top: 0 !important;
      border: none !important;
      display: inline;
      vertical-align: text-bottom;
      background-color: #777777;
      border-radius: 100%;
      padding: 3px 5px;
      font-size: 12px;
    }
  }

  & > div:first-child {
    color: black;
  }
}

.pampas-import-file-container {
  padding: 20px;
  border-bottom: 1px solid #bccde6;
  border-top: 1px solid #bccde6;

  & > label {
    margin-right: 45px;
  }

  & > div {
    display: inline-block;

    & > input {
      outline: none;
      padding: 7px 8px;
      border-radius: 3px;
      border: 1px solid #d5d5d5;
      background-color: #eeeeee;
      color: #a5a5a5;
      margin-right: 15px;
      font-size: 12px;
    }
  }
}

.pampas-import-preview {
  & > p {
  }

  & > div {
    & > p {
      text-indent: 2em;
      background-color: #f5f5f5;
      padding: 5px 0;
      border-bottom: 1px solid #bccde6;
      border-top: 1px solid #bccde6;
      font-weight: 700;
    }
  }
}
</style>
